import PhoneIcon from '@mui/icons-material/Phone';
import { IconButton } from '@mui/material';
import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus';
import { FC, useCallback } from 'react';

export interface PhoneOnlyPatitentActionsProps {
  phoneNumber: string;
}

export const PhoneOnlyPatitentActions: FC<PhoneOnlyPatitentActionsProps> = (props) => {
  const { publish } = useEventBus();

  const handlePhoneClick = useCallback(() => {
    publish({
      messageType: 'startCall',
      data: { phoneNumber: props.phoneNumber }
    });
  }, [publish]);

  return (
    <>
      <IconButton size="large" onClick={handlePhoneClick} sx={{ backgroundColor: 'rgba(235, 245, 255, 1)' }}>
        <PhoneIcon fontSize="inherit" color="primary" />
      </IconButton>
    </>
  );
};
